import { useGetShareAvailabilityQuery } from '../services/shareApi';

/** Whether the team email can be sent here: not known yet, yes, or no. */
export type TeamEmail = 'pending' | 'on' | 'off';

/**
 * Whether this environment can send the team email (handoff §4.1), read
 * fresh each time a form that sends it mounts: Internal Share (DV-3715) and
 * Make Visible & Notify (DV-3563). A failed read is treated as "no", as
 * asset-service answers when it cannot tell.
 */
export const useTeamEmail = (): TeamEmail => {
  const { currentData, isFetching, isError } = useGetShareAvailabilityQuery(undefined, {
    refetchOnMountOrArgChange: true
  });
  if (currentData !== undefined) return currentData.team ? 'on' : 'off';
  if (isError && !isFetching) return 'off';
  return 'pending';
};
